import React, {useState, useEffect} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import "./GeneralInfo.css";

export default function GeneralInfo() {

    const [show, showed] = useState(true);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setTimeout(() => {showed(true)}, 7000);
    }, []);

    var button = function() {
        if (show) {
             return (
                <OverlayTrigger
                key="up"
                trigger={['click']}
                placement="top"
                overlay={
                  isOpen
                    ? ({
                        placement,
                        arrowProps,
                        show: _show,
                        popper,
                        ...props
                      }) => (
                        <div
                          {...props}
                          style={{
                            width: "40vw",
                            textAlign: "justify",
                            fontSize: "calc(8px + 0.5vw)",
                            backgroundColor: "#b4f3e3",
                            padding: "2px 10px",
                            color: "#0326",
                            borderRadius: 3,
                            fontFamily: "var(--font-family-orbitron)",
                            zIndex: "10000",
                            ...props.style,
                          }}
                        >
                          {msg}
                        </div>
                      )
                    : ({
                        placement,
                        arrowProps,
                        show: _show,
                        popper,
                        ...props
                      }) => (
                        <div
                          {...props}
                          style={{
                            display: "none",
                            ...props.style,
                          }}
                        />
                      )
                }
              >
                  <button className="plusButton" onClick={() => onClick()} ><FontAwesomeIcon style={{color: "white"}} icon={faPlus} /></button>
              </OverlayTrigger>
             );
        }     
    }
    
    var onClick = function() {
        setIsOpen(!isOpen);
    }

    var msg = "Localizado no coração de Estarreja. Novidades em breve!";

    return (
        <section>
            {button()}
        </section>       
        );
}